/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Boost - 218842 */

const customize = {
  crossOOSProductSwatches: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductSwatch", {
      name: "Cross out OOS swatches #218842",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          const swatchOptions = element?.getParams()?.props?.options;
          const productData =
            componentRegistry
              .getNearestParentElm(element, "ProductItemWidget")
              ?.getParams()?.props?.product ||
            componentRegistry
              .getNearestParentElm(element, "QuickView")
              ?.getParams()?.props?.productData;
          if (swatchOptions?.length && productData) {
            const productVariants = productData.variants || [];
            swatchOptions.forEach((option) => {
              const optionValue = option.value;
              option.available = checkOptionStatus(
                productVariants,
                optionValue
              );
              if (!option.available) {
                const swatchOption = document.querySelector(
                  `label[for*="${option.id}"]`
                );
                if (
                  swatchOption &&
                  swatchOption.closest(".boost-sd__product-swatch-option")
                ) {
                  swatchOption
                    .closest(".boost-sd__product-swatch-option label")
                    .classList.add("sold-out");
                }
              }
            });
          }
        },
      }),
    });
  },
  translateSize: (componentRegistry) => {
    componentRegistry.useComponentPlugin("QuickView", {
      name: "translate size in quick view",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            if (element.getParams().props.isOpen) {
              const rootElm = element.getRootElm();
              if (rootElm.querySelector(".boost-sd__product-swatch-title")) {
                const swatchTitle = rootElm.querySelector(
                  ".boost-sd__product-swatch-title"
                );
                if (
                  swatchTitle.textContent == "Title" ||
                  swatchTitle.textContent == "Size"
                ) {
                  swatchTitle.textContent = "Talla";
                }
              }
              
            }
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  },
};

function checkOptionStatus(variants, optionValue) {
  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    const variantOptions = variant.title?.split(" / ") || [];
    if (
      variantOptions.some(
        (option) =>
          option.toLowerCase() === optionValue.toLowerCase() &&
          variant.available
      )
    ) {
      return true;
    }
  }
  return false;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.crossOOSProductSwatches,
  customize.translateSize,
]);

// if(boostSDAppConfig?.filterSettings) {
//   boostSDAppConfig.filterSettings.productAndVariantAvailable = false
// }
